import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/home/index.vue';
import LoginAfter from '@/views/home/LoginAfter.vue';
import LoginBefore from '@/views/home/LoginBefore.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'home',
          component: LoginAfter,
        },
      ],
    },
    {
      path: '/login',
      component: Home,
      children: [
        {
          path: '',
          name: 'login',
          component: LoginBefore,
        },
      ],
    },

  ],
});
